<template>
  <el-pagination
    align="right"
    :page-sizes="[10, 20, 50]"
    layout="total, sizes, prev, pager, next, jumper"
    v-bind="$attrs"
    v-on="$listeners"
  >
  </el-pagination>
</template>

<script>
export default {
  name: 'Pagination',
  inheritAttrs: true
}
</script>

<style>
</style>
